import React from 'react'
import { Table, Row, Col, Container, Button } from 'reactstrap'
import { $Category } from '../Middleware';
import { Link } from 'react-router-dom';
import AddCat from './AddCat';

export default class Category extends React.Component {
    state = {
        cats: []
    }
    componentDidMount() {
        this.getCats();
    }
    getCats = () =>{
        $Category.getCategories(false).then(res => {
            this.setState({ cats: res });
        })
    }
    render() {
        return (
            <div>
                <h1 className="page-heading">Category
                <Link to="/adminGallery"><Button className="theme-button" size="sm"
                        style={{ float: 'right', marginRight: '5px' }}
                    > Back to Gallery
                    </Button>
                    </Link>
                </h1>
                <div className="blank-page">
                    <Container>

                        <AddCat cats={this.state.cats} onsuccess={this.getCats}/>

                        <Row>
                            <Col md={{ size: 8, offset: 2 }}>
                                <Table bordered>
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>Category Name</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            this.state.cats.map((cat, ind) => (
                                                <tr key={ind}>
                                                    <td>{ ind + 1}</td>
                                                    <td>{cat.cname}</td>
                                                    <td>

                                                    </td>
                                                </tr>
                                            ))
                                        }
                                    </tbody>
                                </Table>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/admin/Category.jsx